"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _TemplatePurposeOptions = _interopRequireDefault(require("../constants/TemplatePurposeOptions"));

var _TemplatePurposeOptionsArray = _interopRequireDefault(require("../constants/TemplatePurposeOptionsArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _default = _react.default.createClass({
  displayName: "TemplatePurposeDropdown",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    templatePurposeFilter: _react.PropTypes.string.isRequired
  },
  handlePurposeUpdate: function handlePurposeUpdate(event) {
    var params = {};
    params[_GoodFiltersAndPage.default.TEMPLATE_PURPOSE] = event.target.value;
    return this.props.onGoodFilterChange(params);
  },
  render: function render() {
    var templatePurposeFilter = this.props.templatePurposeFilter;
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "is--heading-7 m-bottom-1"
    }, (0, _langUtils.getTemplatePurposeOptionText)('title')), _react.default.createElement(_UIDropdown.default, {
      buttonClassName: "integrate-intent-dropdown p-all-0",
      buttonText: (0, _langUtils.getTemplatePurposeOptionText)(templatePurposeFilter),
      buttonUse: "transparent",
      placement: "bottom right"
    }, _react.default.createElement(_UITypeahead.default, {
      onChange: this.handlePurposeUpdate,
      options: (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)(_TemplatePurposeOptionsArray.default, _langUtils.getTemplatePurposeOptionText, _TemplatePurposeOptions.default.ALL),
      value: templatePurposeFilter
    })));
  }
});

exports.default = _default;
module.exports = exports.default;